import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';
import { Api } from '../../application/panelApi';
import { errText } from '../../lib/format';
import { DEFAULT_TEMPLATE, toForm, type Donor, type ProfileTemplate, type TemplateForm } from './model';

export type ProfileTools = {

  template: ProfileTemplate | null;
  setTemplate: Dispatch<SetStateAction<ProfileTemplate | null>>;

  form: TemplateForm;
  setForm: Dispatch<SetStateAction<TemplateForm>>;
  engineChromium: number;
  donors: Donor[];
  setDonors: Dispatch<SetStateAction<Donor[]>>;

  error: string;
};


export function useProfileTools(enabled: boolean): ProfileTools {
  const [template, setTemplate] = useState<ProfileTemplate | null>(null);
  const [form, setForm] = useState<TemplateForm>(() => toForm(DEFAULT_TEMPLATE));
  const [engineChromium, setEngineChromium] = useState(0);
  const [donors, setDonors] = useState<Donor[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    void (async () => {
      try {
        const data = (await Api.profileTemplate.get()) as { template?: ProfileTemplate; engineChromium?: number };
        if (!data?.template) throw new Error('Шаблон недоступен - обновите control-панель');
        if (!alive) return;
        setTemplate(data.template);
        setEngineChromium(data.engineChromium || 0);
        setForm(toForm(data.template));
        setError('');
      } catch (err) {
        if (alive) setError(errText(err));
        return;
      }
      try {
        const lib = (await Api.fpLibrary.list()) as { donors?: Donor[] };
        if (alive) setDonors(lib.donors || []);
      } catch {
        if (alive) setDonors([]);
      }
    })();
    return () => {
      alive = false;
    };
  }, [enabled]);

  return { template, setTemplate, form, setForm, engineChromium, donors, setDonors, error };
}
